export default __webpack_public_path__ + "static/media/fastclix_lancing_kit.4eecc681.webp";